import type { IconData } from '@stacksjs/iconify-core'

export const watch1Flat: IconData = {
  "body": "<g fill=\"none\"><path fill=\"#2859c5\" d=\"M24 1.5c-2.621 0-4.585.174-5.998.383c-2.09.31-3.514 1.957-4 3.915L9.873 22.434a6.5 6.5 0 0 0 0 3.132l4.129 16.636c.486 1.958 1.91 3.605 4 3.915c1.413.209 3.377.383 5.998.383c2.62 0 4.584-.174 5.998-.383c2.09-.31 3.513-1.957 4-3.915l4.128-16.636a6.5 6.5 0 0 0 0-3.132L33.997 5.798c-.486-1.958-1.909-3.605-4-3.915C28.585 1.674 26.62 1.5 24 1.5\"/><path fill=\"#8fbffa\" fill-rule=\"evenodd\" d=\"M7.5 24c0-9.113 7.387-16.5 16.5-16.5S40.5 14.887 40.5 24S33.113 40.5 24 40.5S7.5 33.113 7.5 24\" clip-rule=\"evenodd\"/></g>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default watch1Flat
